module.exports = __webpack_public_path__ + "img/DK17912828.e4a4babd.png";